/**
 * Minimal character field utilities - focused on reducing code duplication
 */

import { normalizeGender } from './genderUtils.js';

// Simple field accessors that handle all variations
export const getOutfitId = (char) => char?.outfitId ?? char?.outfit_id ?? 0;

// Most common use cases
export function prepareSpriteParams(character, emotion = null, action = null, index = 0, updateImage = true) {
    // Use spriteState values if available, otherwise fall back to character properties or null
    // null means let the fetch layer use worker pick or apply legacy mapping
    const finalEmotion = emotion ?? character?.spriteState?.emotion ?? null;
    const finalAction = action ?? character?.spriteState?.action ?? null;
    const finalOutfitId = character?.spriteState?.outfitId ?? getOutfitId(character);

    return [
        character?.id,
        finalEmotion,
        finalOutfitId,
        index,
        updateImage,
        finalAction
    ];
}

export function createHangoutCharacterData(sourceCharacter, additionalData = {}) {
    return {
        id: sourceCharacter?.id,
        name: sourceCharacter?.name ?? 'Character',
        outfitId: getOutfitId(sourceCharacter),
        gender: normalizeGender(sourceCharacter),
        isActive: true,
        ...additionalData
    };
}
